var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.4A6.4 6.4 0 108 3.6a6.4 6.4 0 000 12.8z",
    fill: "#4C6AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68 7.06a.5.5 0 00-.5-.5h-.36a.5.5 0 00-.5.5v.36a.5.5 0 00.5.5h.36a.5.5 0 00.5-.5v-.36zm0 2.28a.5.5 0 00-.5-.5h-.36a.5.5 0 00-.5.5v3.56a.5.5 0 00.5.5h.36a.5.5 0 00.5-.5V9.34z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/exclamation.9b08506b.svg";
export { SvgExclamation as ReactComponent };